import React from "react";
import CustomCard from "../../../components/d-reusable/CustomCard";

import facebookIcon from "../../../../assets/dental-inden/icons/facebookIcon.svg";
import youtubeIcon from "../../../../assets/dental-inden/icons/youtubeIcon.svg";
import instaIcon from "../../../../assets/dental-inden/icons/instaIcon.svg";
import linkdinIcon from "../../../../assets/dental-inden/icons/linkdinIcon.svg";
import websiteIcon from "../../../../assets/dental-inden/icons/websiteIcon.svg";
import { useSelector } from "react-redux";

const AboutUsScreen = () => {
  const { siteData } = useSelector((state) => state.general);
  const openSocialMedia = (url) => {
    if (url) {
      const formattedUrl = url.startsWith("http") ? url : `https://${url}`;
      window.open(formattedUrl, "_blank", "noopener,noreferrer");
    } else {
      console.warn("URL is not available");
    }
  };

  return (
    <CustomCard>
      <div className="about_us_screen_container">
        <p className="_heading">About Dental ID</p>
        <div className="about_us_screen_body">
          <p className="description">
            Dental Identification app mission is to enable professionals to
            communicate and conduct virtual testing using a standardized
            approach, which increases the accuracy of the assessment to make
            reporting more efficient and effective.
          </p>
          <br />
          <br />
          <p className="_heading">Follow Us</p>
          <div
            className="about_us_links"
            onClick={() => openSocialMedia(siteData?.Facebook)}
          >
            <img src={facebookIcon} alt="facebook" />
            <p>Facebook</p>
          </div>
          <div
            className="about_us_links"
            onClick={() => openSocialMedia(siteData?.Instagram)}
          >
            <img src={instaIcon} alt="Instagram" />
            <p>Instagram</p>
          </div>
          <div
            className="about_us_links"
            onClick={() => openSocialMedia(siteData?.Linkedin)}
          >
            <img src={linkdinIcon} alt="LinkdIn" />
            <p>LinkdIn</p>
          </div>
          <div
            className="about_us_links"
            onClick={() => openSocialMedia(siteData?.Youtube)}
          >
            <img src={youtubeIcon} alt="YouTube" />
            <p>YouTube</p>
          </div>
          <div
            className="about_us_links"
            onClick={() => openSocialMedia(siteData?.Website)}
          >
            <img src={websiteIcon} alt="Website" />
            <p>Webiste</p>
          </div>
        </div>
      </div>
    </CustomCard>
  );
};

export default AboutUsScreen;
